import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m11.3 7.3-6-6c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l6 6-6 6c-.2.2-.2.5 0 .7.1.1.2.1.3.1s.3 0 .4-.1l6-6c.4-.4.4-1 0-1.4" />
  </svg>
);
const SvgCaretLeftNext = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="caret-left-next" {...props} />;
export default SvgCaretLeftNext;
